const RestrictedDateIcon = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="#A8ADB2"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M23 8H22V6H20V8H12V6H10V8H9C7.89 8 7.01 8.9 7.01 10L7 24C7 25.1 7.89 26 9 26H23C24.1 26 25 25.1 25 24V10C25 8.9 24.1 8 23 8ZM23 24H9V14H23V24Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3114 19L19.7071 16.6043L18.3957 15.2929L16 17.6886L13.6043 15.2929L12.2929 16.6043L14.6886 19L12.2929 21.3957L13.6043 22.7071L16 20.3114L18.3957 22.7071L19.7071 21.3957L17.3114 19ZM13.6043 22L13.6043 22L16 19.6043L16 19.6043L13.6043 22ZM18.3957 22L18.3957 22L19 21.3957L19 21.3957L18.3957 22ZM16.6043 19L19 16.6043L19 16.6043L16.6043 19L16.6043 19Z"
      />
    </g>
  </svg>
)

export default RestrictedDateIcon
